import React from 'react';
import useStore from './store';
import CustomScroll from './components/CustomScroll';
const Step6 = () => {
    const { setClose } = useStore();
    return (React.createElement(CustomScroll, null,
        React.createElement("div", { className: "step-7" },
            React.createElement("h2", null,
                "Thanks for",
                React.createElement("br", null),
                React.createElement("span", null, "completing the form!"),
                "\u00A0\uD83D\uDE4C\u00A0"),
            React.createElement("p", null, "We've got your details and will be in touch soon."),
            React.createElement("div", { className: 'mb-auto mt-3' },
                React.createElement("button", { className: 'btn btn-cta', onClick: setClose }, "Close")))));
};
export default Step6;
